module.exports = __webpack_public_path__ + "img/fedding1.f0392e55.png";